// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main[data-v-beb7f5ec],.model[data-v-beb7f5ec]{width:100%}.model[data-v-beb7f5ec]{position:fixed;top:0;left:0;z-index:999;height:100%;background:url(http://source.allosoft.top//web/h5-ad-spread/mantle.png) no-repeat;background-size:100% 100%}", ""]);
// Exports
module.exports = exports;
